import { render } from "./pet.vue?vue&type=template&id=3189291e"
import script from "./pet.vue?vue&type=script&lang=js"
export * from "./pet.vue?vue&type=script&lang=js"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__